import React, { useState } from "react";
import { CalendarCheck, Eye, Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";

export const AdminWeeklyProgress = () => {
  const [html, setHtml] = useState("");
  const [busy, setBusy] = useState("");
  const preview = async (quiet) => {
    const { data } = await api.get(`/admin/weekly-progress/preview?quiet=${quiet}`, { responseType: "text" });
    setHtml(data);
  };
  const test = async (quiet) => {
    setBusy(quiet ? "quiet" : "active");
    try { const { data } = await api.post("/admin/weekly-progress/test", { quiet }); toast.success(`Test email sent to ${data.to}`); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy("");
  };
  return (
    <section className="mt-14" data-testid="admin-weekly-progress">
      <div className="flex items-center gap-2"><CalendarCheck size={18} className="text-primary" /><h2 className="font-serif text-2xl">Weekly progress email</h2></div>
      <p className="mt-1 text-sm text-muted-foreground">
        Sent to every student with Email reminders on. <span className="font-medium text-foreground" data-testid="weekly-progress-status">Not switched on yet</span>. Check the wording below, then ask to turn it on.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button size="sm" variant="outline" className="rounded-full" onClick={() => preview(false)} data-testid="weekly-preview-active"><Eye size={14} className="mr-1.5" /> Preview: active week</Button>
        <Button size="sm" variant="outline" className="rounded-full" onClick={() => preview(true)} data-testid="weekly-preview-quiet"><Eye size={14} className="mr-1.5" /> Preview: quiet week</Button>
        <Button size="sm" variant="outline" className="rounded-full" disabled={!!busy} onClick={() => test(false)} data-testid="weekly-test-active"><Mail size={14} className="mr-1.5" /> {busy === "active" ? "Sending…" : "Email me the active version"}</Button>
        <Button size="sm" variant="outline" className="rounded-full" disabled={!!busy} onClick={() => test(true)} data-testid="weekly-test-quiet"><Mail size={14} className="mr-1.5" /> {busy === "quiet" ? "Sending…" : "Email me the quiet version"}</Button>
      </div>
      {html && <iframe title="Weekly progress email preview" srcDoc={html} sandbox="allow-same-origin" className="mt-4 h-[640px] w-full max-w-2xl rounded-2xl border border-border bg-white" data-testid="weekly-preview-frame" />}
    </section>
  );
};
